import React from 'react';
import Lock from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/download.svg';
// import Unlock from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/unlock.svg';
// import CopyGold from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/copy-gold.svg';
import Icon from 'components/canvas/components/icon';
import { useTranslation } from 'i18n';
import { useCanvasClipboardOperations } from 'state/canvas-clipboard';
import { useSelectedNodeOperations } from 'state/canvas/selected-node';
import { toast } from 'services/toast';
import { KonvaEventObject } from 'konva/lib/Node';
import { SurfaceBackgroundNode, SurfaceNodeUnion } from 'graphql/types';
import useSaveSurfaceBackgroundNode from 'routes/surface/components/node-modal-form/hooks/use-save-surface-background-node';
import axios from 'axios';
import fileDownload from 'js-file-download';
import useProxyUrl from 'hooks/use-proxy-url';

export interface LockIconProps {
  node?: SurfaceNodeUnion;
  isSelected?: boolean;
  onClick?: (event: KonvaEventObject<MouseEvent>) => void;
  width?: number;
  height?: number;
}

const defaultProps = {
  isSelected: false,
};

function DownloadIcon(props: LockIconProps) {
  const { t } = useTranslation();
  const { node } = props;
  const x = node as SurfaceBackgroundNode;
  const { addNodesForCopyToClipboard } = useCanvasClipboardOperations();
  const saveSurfaceImageNode = useSaveSurfaceBackgroundNode('');
  const { clearSelectedNode } = useSelectedNodeOperations();
  const [isSelected, setSelected] = React.useState<boolean>(false);

  const src = Lock;

  function isFromRis(url): boolean {
    return url?.includes('ris.bka.gv.at');
  }

  const proxyUrl = useProxyUrl();

  const download = (node) => {
    console.warn('DOWNLOAS', node);
    const { url, name, format } = node;

    const finaleurl = isFromRis(url) ? proxyUrl.concat(url) : url;
    axios
      .get(finaleurl, {
        responseType: 'blob',
      })
      .then((response) => {
        const filename = `${name}.${format.toLowerCase()}`;
        fileDownload(response.data, filename);
      })
      .catch((er) => {
        console.log('ERROR ', er);
      });
  };

  async function copyNode(node) {
    if (node) {
      // toast.success(
      //   t(node.isFixed?`Background Unocked `: `Background Locked `, {
      //     replace: { name: node?.name || '' },
      //   }),
      // );
      // //addNodesForCopyToClipboard([node]);
      // console.warn(" UPDaTE NODE ", node)
      // const input =   {id:node.id,
      //   name:node.name,
      // isFixed:!node.isFixed
      // }
      // const response = await saveSurfaceImageNode({ variables: { input } });
      download(node);

      // if (response.isFailure) {
      //  // setSubmitting(false);
      //   toast.error(response.getErrorMessage());

      //   return response;
      // }
      // clearSelectedNode();
    }
  }

  function onClick(event) {
    event.cancelBubble = true;

    if (node) {
      copyNode(node);
    }

    props.onClick && props.onClick(event);
  }

  return (
    <Icon
      {...props}
      src={src}
      onClick={onClick}
      /*   onMouseOver={() => setSelected(true)}
      onMouseOut={() => setSelected(false)} */
    />
  );
}

DownloadIcon.defaultProps = defaultProps;

export default DownloadIcon;
